import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { allMovies, categories } from "@/lib/movies";
import { contentScope } from "@/mocks/site";

const steps = [
  {
    no: "01",
    icon: "ri-search-eye-line",
    title: "找到想看的片",
    desc: "按分类浏览，或用关键词、年份、评分组合筛选，缩小范围。",
  },
  {
    no: "02",
    icon: "ri-file-list-3-line",
    title: "先看资料再决定",
    desc: "导演、主演、片长、剧情简介与类型标签，一次看清。",
  },
  {
    no: "03",
    icon: "ri-play-circle-line",
    title: "进入观影界面",
    desc: "播放区域为界面演示，用于展示完整观影流程与交互。",
  },
];

export default function IntroSection() {
  return (
    <section className="px-4 md:px-8 lg:px-12 py-14 md:py-20">
      <div className="max-w-shell mx-auto">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-14 items-center">
          <div className="relative h-[300px] md:h-[420px] rounded-lg overflow-hidden border border-background-200/70">
            <img
              src="https://readdy.ai/api/search-image?query=Cinematic%20moody%20Korean%20cinema%20interior%2C%20empty%20art%20house%20screening%20room%20with%20warm%20amber%20wall%20lamps%20and%20dark%20charcoal%20velvet%20seats%2C%20projector%20beam%20cutting%20through%20haze%2C%20soft%20film%20grain%2C%20elegant%20atmosphere%2C%20no%20people%2C%20no%20text&width=1000&height=1200&seq=home-intro-2026&orientation=portrait"
              alt="韩国伦理电影观影空间氛围"
              title="韩国伦理电影在线观看 - 观影空间"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/20 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6 grid grid-cols-3 gap-3">
              {[
                { value: `${allMovies.length}+`, label: "影片资料" },
                { value: `${categories.length - 1}`, label: "内容分类" },
                { value: "48h", label: "资料校对" },
              ].map((stat) => (
                <div key={stat.label} className="rounded-md bg-background-50/70 backdrop-blur-sm border border-background-200/60 px-3 py-2.5">
                  <p className="font-label text-xl md:text-2xl text-primary-500 leading-none">{stat.value}</p>
                  <p className="mt-1 text-[11px] text-foreground-600">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <SectionHeading
              eyebrow="ABOUT THE ARCHIVE"
              title="一个认真整理韩影资料的地方"
              description="韩国伦理电影在线观看专注于韩国伦理题材电影的收集与呈现，把影片资料、分类体系与观影界面放在同一个地方，让找片这件事变得简单。"
            />

            <div className="grid sm:grid-cols-2 gap-4 mt-7">
              {contentScope.map((item) => (
                <div
                  key={item.title}
                  className="rounded-lg border border-background-200/70 bg-background-100/40 p-4 hover:border-primary-400/50 transition-colors"
                >
                  <span className="w-8 h-8 rounded-md bg-secondary-100 text-secondary-900 flex items-center justify-center mb-3">
                    <i className={`${item.icon} text-base`} aria-hidden="true"></i>
                  </span>
                  <h3 className="text-sm font-medium text-foreground-950">{item.title}</h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
                </div>
              ))}
            </div>

            <Link
              to="/about"
              className="mt-6 inline-flex items-center gap-2 text-sm text-primary-500 hover:text-primary-400 transition-colors cursor-pointer"
            >
              了解站点与团队
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>
        </div>

        <div className="mt-14 md:mt-20">
          <SectionHeading eyebrow="HOW IT WORKS" title="三步开始观影" />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {steps.map((step) => (
              <div
                key={step.no}
                className="relative rounded-lg border border-background-200/70 bg-background-50 px-5 py-6 overflow-hidden"
              >
                <span className="absolute top-4 right-5 font-label text-4xl text-background-300/60">
                  {step.no}
                </span>
                <span className="w-10 h-10 rounded-md bg-primary-500/15 text-primary-400 flex items-center justify-center mb-4">
                  <i className={`${step.icon} text-lg`} aria-hidden="true"></i>
                </span>
                <h3 className="font-heading text-base text-foreground-950 font-semibold">{step.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}